<template>
  <div>
    <form v-on:submit.prevent="handleUpdateEmailSetting">
      <div>
        <label for="serverApiToken" class="block text-sm font-medium text-gray-700">Server Api Token</label>
        <div class="my-1 relative rounded-md shadow-sm">
          <input
              v-model="emailSetting.serverApiToken"
              type="text"
              name="serverApiToken"
              id="serverApiToken"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Token" />
        </div>
        <div
            v-for="error in v$.emailSetting.serverApiToken.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
        <label for="fromName" class="block text-sm font-medium text-gray-700">From Name</label>
        <div class="my-1 relative rounded-md shadow-sm">
          <input
              v-model="emailSetting.fromName"
              type="text"
              name="fromName"
              id="fromName"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Name" />
        </div>
        <div
            v-for="error in v$.emailSetting.fromName.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
        <label for="fromEmail" class="block text-sm font-medium text-gray-700">From Email</label>
        <div class="my-1 relative rounded-md shadow-sm">
          <input
              v-model="emailSetting.fromEmail"
              type="text"
              name="fromEmail"
              id="fromEmail"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Email" />
        </div>
        <div
            v-for="error in v$.emailSetting.fromEmail.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
        <label for="bccEmail" class="block text-sm font-medium text-gray-700">BCC Email</label>
        <div class="my-1 relative rounded-md shadow-sm">
          <input
              v-model="emailSetting.bccEmail"
              type="text"
              name="bccEmail"
              id="bccEmail"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Email" />
        </div>
        <div
            v-for="error in v$.emailSetting.bccEmail.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
        <label for="replytoEmail" class="block text-sm font-medium text-gray-700">Reply To Email</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
              v-model="emailSetting.replytoEmail"
              type="text"
              name="replytoEmail"
              id="replytoEmail"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Email" />
        </div>
        <div
            v-for="error in v$.emailSetting.replytoEmail.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
        <label for="quill-template" class="block text-sm font-medium text-gray-700">Signature</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div id="quill-template" class="mt-1">
            <quill @update:quillBody="setBody" :quillBody="emailSetting.signature" />
          </div>
        </div>
      </div>

      <div class="mt-3">
        <primary-button class="mr-2" @click="handlePreviewSignature" text="Preview" />
        <primary-button :disabled="v$.$invalid" @click="handleUpdateEmailSetting" text="Update Email Setting" />
      </div>

      <div class="mt-5">
        <h1 class="text-xl">
          Preview
        </h1>
        <div class="p-2 border border-black">
          <email-preview :preview-content="previewSignature" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import Quill from "@/components/Functional/Quill/Quill";
import EmailPreview from "@/components/Functional/EmailPreview/EmailPreview";
import gravyAxios from "@/plugins/axios";
import useVuelidate from "@vuelidate/core";
import {email, required} from "@vuelidate/validators";
export default {
  name: "UpdateEmailSettingsForm",
  components: {
    PrimaryButton,
    Quill,
    EmailPreview
  },
  computed: {
    emailSetting() {
      return this.$store.getters.getEmailSetting
    }
  },

  data() {
    return {
      v$: useVuelidate(),
      previewSignature: "Click preview to test",
      previewed: false,
      emailSettingCopy: {}
    }
  },
  errorCaptured(err, vm, info) {
    this.$store.dispatch('createAlert', {
      type: 'danger',
      message: err
    })
  },
  methods: {
    setBody(body) {
      this.emailSetting.signature = body
    },
    async handlePreviewSignature() {
      this.$store.dispatch('showLoadingSpinner')

      this.errors = []
      try {
        await this.$store.dispatch('previewSignature', { body: this.emailSetting.signature })
        this.previewSignature = this.$store.getters.getPreviewSignature.body
        this.previewed = true
      } catch (e) {
        this.errors = e.response.data.errors
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')
    },
    async handleUpdateEmailSetting() {
      this.$store.dispatch('showLoadingSpinner')

      try {

        await this.$store.dispatch('updateEmailSetting', this.emailSetting)

        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Email Setting Successfully Updated'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('closeUpdateEmailSettingPanel')
      this.$store.dispatch('hideLoadingSpinner')

    },

  },
  validations: {
    emailSetting: {
      serverApiToken: { required },
      fromName: { required  },
      fromEmail: { required, email },
      bccEmail: { email },
      replytoEmail: { required, email },
    },
  }

}
</script>

<style scoped>

</style>
